// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3jXpc","footer":"Form_footer__1pD6q"};